import Label from "../../Common/Label";
import Tag from "../../Common/Tag";

type Props = {
    googleUrl: string | undefined;
    openingHours: google.maps.places.PlaceOpeningHours | undefined;
};

function OpeningHours(props: Props) {
    const { googleUrl, openingHours } = props;

    return googleUrl && openingHours ? (
        <>
            {openingHours.isOpen() ? (
                <Tag.XSmall.Bold.P90>Open</Tag.XSmall.Bold.P90>
            ) : (
                <Tag.XSmall.Bold.Y80>Closed</Tag.XSmall.Bold.Y80>
            )}

            <a href={googleUrl} target="_blank" rel="noreferrer">
                <Label.XSmall.SemiBold.N50>
                    View opening hours
                </Label.XSmall.SemiBold.N50>
            </a>
        </>
    ) : (
        <Label.XSmall.SemiBold.N60>Opening hours unavailable</Label.XSmall.SemiBold.N60>
    );
}

export default OpeningHours;
